import AppNexus from '@components/AppNexus'
import nanoid from '@utils/random'
import { AdSlide } from '@widgets/Gallery/types'
import { FunctionComponent, memo, useEffect, useMemo, useRef } from 'react'
import styled from 'styled-components'

const GalleryAdSlideWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  justify-items: center;
  align-items: center;
`

type GalleryAdSlideProps = {
  adSlide: AdSlide
  galleryUUID: string
  index: number
  isActive: boolean
}

const GalleryAdSlide: FunctionComponent<GalleryAdSlideProps> = (props) => {
  const { adSlide, galleryUUID, index, isActive } = props
  const adKeyRef = useRef<string>('')
  const containerId = `${galleryUUID}-${index}`
  const { kind, ...restOfAdProps } = adSlide
  const processedAdSlide = useMemo(
    () => ({ ...restOfAdProps, containerId, autoLoadSlot: true }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [containerId]
  )

  useEffect(() => {
    if (isActive) {
      adKeyRef.current = nanoid()
    }
  }, [isActive])

  return (
    <GalleryAdSlideWrapper>
      {isActive && <AppNexus {...processedAdSlide} key={adKeyRef.current} />}
    </GalleryAdSlideWrapper>
  )
}

const MemoizedGalleryAdSlide = memo(GalleryAdSlide)

MemoizedGalleryAdSlide.displayName = 'MemoizedGalleryAdSlide'

export default MemoizedGalleryAdSlide
